document.addEventListener("DOMContentLoaded", () => {
  const headerContentWrapper = document.querySelector(
    ".header__content-wrapper"
  );

  const setupSearchModal = (containerSelector) => {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const summaryButton = container.querySelector(".header__icon--summary");
    const closeButton = container.querySelector(".search-modal__close-button");
    const modalOverlay = container.querySelector(".modal-overlay");
    const detailsElement = container.querySelector("details");

    if (container) {
      detailsElement.addEventListener("toggle", () => {
        if (detailsElement.hasAttribute("open")) {
          document.documentElement.classList.add("no-scroll");
        } else {
          document.documentElement.classList.remove("no-scroll");
        }
      });
    }

    const closeModal = () => {
      if (detailsElement) {
        detailsElement.removeAttribute("open");
      }
      setTimeout(() => {
        document.documentElement.classList.remove("no-scroll");
      });
    };

    if (summaryButton) {
      summaryButton.addEventListener("click", () => {
        headerContentWrapper.style.position = "unset";
      });
    }

    if (closeButton) {
      closeButton.addEventListener("click", closeModal);
    }

    if (modalOverlay) {
      modalOverlay.addEventListener("click", closeModal);
    }
  };

  setupSearchModal(".header-search-desktop");
  setupSearchModal(".header-search-mobile");
});
